"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOas2Operation = exports.transformOas2Operations = void 0;
const context_1 = require("../oas/context");
const operation_1 = require("../oas/operation");
const request_1 = require("./transformers/request");
const responses_1 = require("./transformers/responses");
const securities_1 = require("./transformers/securities");
const servers_1 = require("./transformers/servers");
function transformOas2Operations(document, ctx) {
    return (0, operation_1.transformOasOperations)(document, exports.transformOas2Operation, void 0, ctx);
}
exports.transformOas2Operations = transformOas2Operations;
const transformOas2Operation = ({ document: _document, path, method, ctx = (0, context_1.createContext)(_document), }) => {
    const httpOperation = operation_1.transformOasOperation.call(ctx, path, method);
    const pathObj = ctx.maybeResolveLocalRef(ctx.document.paths[path]);
    const operation = ctx.maybeResolveLocalRef(pathObj[method]);
    return {
        ...httpOperation,
        responses: responses_1.translateToResponses.call(ctx, operation),
        servers: servers_1.translateToServers.call(ctx, operation),
        request: request_1.translateToRequest.call(ctx, pathObj, operation),
        security: securities_1.translateToSecurities.call(ctx, operation.security),
    };
};
exports.transformOas2Operation = transformOas2Operation;
//# sourceMappingURL=operation.js.map